import { createFileRoute, redirect } from "@tanstack/react-router"

import PermissionDeniedAlert from "@/components/common/Alerts/PermissionDeniedAlert"
import { PermissionActionType } from "@/constants/permissions"
import { useCurrentUserStore } from "@/stores/currentUserStore"

export const Route = createFileRoute("/app/dashboard/")({
  beforeLoad: () => {
    const { currentUser } = useCurrentUserStore.getState()
    const permissions = currentUser?.permissions ?? []

    if (permissions.includes(PermissionActionType.DASHBOARD_PENDING_APPROVALS)) {
      throw redirect({ to: "/app/dashboard/pending-approvals" })
    }

    if (permissions.includes(PermissionActionType.DASHBOARD_MY_REQUESTS)) {
      throw redirect({ to: "/app/dashboard/my-requests" })
    }
  },
  component: () => <PermissionDeniedAlert />,
})
